var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.514 5.77308C19.0979 3.15006 22.9021 3.15006 24.486 5.77308C25.4081 7.30014 27.2167 8.04929 28.9485 7.62152C31.9233 6.88674 34.6133 9.57675 33.8785 12.5515C33.4507 14.2833 34.1999 16.0919 35.7269 17.014C38.3499 18.5979 38.3499 22.4021 35.7269 23.986C34.1999 24.9081 33.4507 26.7167 33.8785 28.4485C34.6133 31.4233 31.9233 34.1133 28.9485 33.3785C27.2167 32.9507 25.4081 33.6999 24.486 35.2269C22.9021 37.8499 19.0979 37.8499 17.514 35.2269C16.5919 33.6999 14.7833 32.9507 13.0515 33.3785C10.0767 34.1133 7.38674 31.4233 8.12152 28.4485C8.54929 26.7167 7.80014 24.9081 6.27308 23.986C3.65006 22.4021 3.65007 18.5979 6.27308 17.014C7.80014 16.0919 8.54929 14.2833 8.12152 12.5515C7.38674 9.57675 10.0767 6.88674 13.0515 7.62152C14.7833 8.04929 16.5919 7.30014 17.514 5.77308Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16L16.5 24M24.5 24L16.5 16",
    stroke: "#FF522D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedStatusIcon);
export default __webpack_public_path__ + "static/media/failedStatusIcon.6d6d0f95985dae7ea10c4bd1e1ea6a60.svg";
export { ForwardRef as ReactComponent };